import React from 'react';
import { Link } from 'react-router-dom';

const Spiritual = () => {
    return (
        <div className="page-container spiritual-page">
            <h1 className="page-title">Spiritual Well-being</h1>
            <p className="page-intro">Welcome to the Spiritual Well-Being section of Wholeness Forward.</p>
          
            {/* Include the image */}
            <img
                src="/images/wf-spiritual2.webp" // Path to image in public folder
                alt="Person meditating"
                className="page-image"
            />
            <p className="page-text">
                Spiritual well-being is about finding purpose, meaning, and connection to something greater than ourselves. 
                It involves aligning with our values, beliefs, and fostering personal growth.
            </p>
            <p className="page-text">
            Spirituality is not limited to any specific religion. It’s about cultivating inner peace, understanding our place in the world, and connecting with others, nature, or a higher power. 
            This enhances our ability to manage stress, build resilience, and maintain balance in life.
            </p>
            <hr className="page-divider" />
            <p className="page-text">
                At Wholeness Forward, we aim to support you on your spiritual journey, providing resources and insights to help you grow spiritually 
                and enhance this key aspect of your overall health. 
            </p>
            <h2 className="page-heading">Subtopics</h2>
            <ul className="content-list">
                <li><Link to="/spiritual/meditation" className="content-link">Meditation and Mindfulness</Link></li>
                <li><Link to="/spiritual/nature" className="content-link">Connecting with Nature</Link></li>
                <li><Link to="/spiritual/gratitude" className="content-link">Gratitude</Link></li>
                {/* <li>Exploring Religion</li>
                <li>Community and Service</li> */}
            </ul>
            <hr className="page-divider" />
            <h3 className="subheading">Community Spiritual Discussion</h3>
            <p className="page-text">Join the conversation and connect with others on their spiritual journey. Share your experiences, ask questions, and gain new insights from fellow community members. Whether you’re new to spiritual practices or have years of experience, your voice matters in building a supportive community.</p>
            <a href="/forum/Spiritual" className="btn">Join the Forum</a>
        </div>
    );
};

export default Spiritual;
